import React, { useContext, useEffect, useState } from 'react'
import Heading from '../../../Components/Heading/Heading'
import { useNavigate } from 'react-router-dom'
import DynamicGrid from '../../../Components/DynamicGrid/DynamicGrid';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import SelectForm from '../../../Components/SelectForm/SelectForm';
import { APICall } from '../../../Helpers/API/APICalls';
import { exportToExcelProductivity, getEmployeeDropdown, getProductivityGridData } from '../../../Helpers/API/APIEndPoints';
import { getContext, LoaderContext } from '../../../Helpers/Context/Context';
import moment from 'moment';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Tooltip } from 'antd';

const Productivity = () => {

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const lastDayOfPreviousMonth = new Date(currentYear, currentMonth, 0);

  const localDate = moment().subtract(1, "months").startOf("month");
  const localDateFormatted = localDate.format("YYYY-MM-DD");

  const navigate  = useNavigate();
  const [toggle, setToggle] = useState(false);
  const [productivityGridData, setProductivityGridData] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [isactive, setIsActive] = useState("active");
  const { EmployeeId, RoleId } = getContext();
  const [date, setDate] = useState<any>(localDateFormatted);
  const [employeeDropdown, setEmployeeDropdown] = useState<any>([]);
  const [selectedEmployee, setSelectedEmployee] = useState<any>([]);
  const [managerDropdown, setManagerDropdown] = useState<any>([]);
  const [selectedManager, setSelectedManager] = useState<any>([]);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [isReset, setIsReset] = useState<any>(false)

  const RoleIdArray = RoleId.split(",");
  const [employeeRoleId, setEmployeeRoleId] = useState(0);

  useEffect(()=>{
    if(RoleIdArray.includes("3"))
      {
        setEmployeeRoleId(3)
      }else if(RoleIdArray.includes("8"))
      {
        setEmployeeRoleId(8);
      }

  }, [])

  useEffect(
    ()=>{
      GetEmployees();
    } 
    ,[employeeRoleId])

   useEffect(
    ()=>{
      GetGridData()
    }
    ,[searchText,
      sortColumn,
      sortDirection,
      start,
      page,
      pageSize,
      isactive,isReset])

    const GetEmployees = async()=>{

      let postObj = {
        RoleId : employeeRoleId,
        EmployeeId : EmployeeId,
      }

          const {data} = await APICall(getEmployeeDropdown,"POST",postObj);
          
          if(data){
    
            const arr =  data.map((ele)=>{
              return{
                value : ele.employeeId,
                label : ele.employeeName,
              }
            })
    
            setEmployeeDropdown(arr)
          }
    
        }

  const handleChange = (event: SelectChangeEvent) => {
      setIsActive(event.target.value);
  };

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,

    setCellHeaderProps: () => ({ align: "center" }),

    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
    // showCustomToolbar ?
    customToolbar: () => {
      return (
        <FormControl sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="Active"
            value={isactive}
            onChange={handleChange}
            sx={{
              width: 80,
              height: 30, // Set the desired height
              "&:focus": { color: "success.main" }, // Change text color to green on focus
            }}
          >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"active"}>Yes</MenuItem>
            <MenuItem value={"inactive"}>No</MenuItem>
          </Select>
        </FormControl>
      );
    },
  };

  const customColors = ["#2755f3", "#27ae60"];
  
  const gridColumns = [
          {
            name: "id",
            label: "Id",
            options: {
              display: false,
              filter: false,
              sort: false,
            },
          },
          {
            name: "productivityDate",
            label: " Date",
            options: {
              filter: false,
              sort: true,
              sortDescFirst: true,
              customBodyRender: (value) =>
                value ? moment(value).format("MMM-YYYY") : "",
            },
          },
          {
            name: "employeeName",
            label: "Name",
            options: {
              filter: false,
              sort: true,
              sortDescFirst: true,
            },
          },
          {
            name: "reportingManagerName",
            label: "Reporting Manager",
            options: {
              filter: false,
              sort: false,
              sortDescFirst: true,
            },
          },
          {
            name: "productivity",
            label: "Productivity",
            options: {
              filter: false,
              sort: false,
              sortDescFirst: true,
              setCellProps: () => ({
                align: "right",
              }),
              setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
              // customBodyRender: (value) => {
              //   return <div style={{ paddingLeft: "80px" }}>{value}</div>;
              // },
            },
          },
          {
              name: "",
              label: "Action",
              options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => {
                  let id = tableMeta.tableData[tableMeta.rowIndex].id;
                  let data =  tableMeta.tableData[tableMeta.rowIndex]
        
                  return (
                    <>
                     <Tooltip title="Edit" color={customColors[0]}>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
        
                          navigate("create", { state: id });
                        }}
                      >
                        <i className="fa fa-pencil" aria-hidden="true"></i>
                      </a>
                      </Tooltip>
                    </>
                  );
                },
              },
          },
          {
            name: "isActive",
            label: "Active Status",
            options: {
              filter: false,
              sort: false,
              customBodyRender: (value, tableMeta) => {
                //console.log('value=>',value)
                if (value) {
                  return <i className="fas fa-check"></i>;
                } else {
                  return <i className="fas fa-times"></i>;
                }
              },
            },
          },
    
  ] 

  const GetGridData = async()=>{
    showLoader();

    const EmpId = selectedEmployee ? selectedEmployee.map((ele) => ele.value).join(", "): 0;
   // const firstDayOfMonth = moment().startOf('month').toDate();
    let obj = {
      //EmployeeId: Number(EmployeeId),
     // RoleId: role ? role : null,
      start: start,
      pageSize: pageSize,
      sortColumn: sortColumn === "" ? "CreatedDate" : sortColumn,
      sortOrder: sortDirection === "" ? "Desc" : sortDirection,
      searchText: searchText,
      activeStatusId: isactive,
      ProductivityDate : date,
      EmployeeIdSearch : selectedEmployee ? EmpId : null,
      //EmployeeIdString : selectedEmployee ? EmpId : null,
      
    }
   // console.log('req obj=>',obj)
    const {data} = await APICall(getProductivityGridData,"POST",obj)
   // console.log('grid data=>',data)

    if (data) {
      setProductivityGridData(data);
      setCount(data[0]?.count)
    } else {
      setPage(0);
      setStart(0);
      setCount(0);
    }
    hideLoader();
  }

  const toggleFilter = () => {
    setToggle(!toggle);
  };


  const ExportToExcel = ()=>{
    //const firstDayOfMonth = moment().startOf('month').toDate();
    const EmpId = selectedEmployee ? selectedEmployee.map((ele) => ele.value).join(", "): 0;
    
    let requestParams ={
      start: start,
      pageSize: pageSize,
      sortColumn: sortColumn === "" ? "CreatedDate" : sortColumn,
      sortOrder: sortDirection === "" ? "Desc" : sortDirection,
      searchText: searchText,
      activeStatusId: isactive,
      ProductivityDate : date,
      EmployeeIdSearch : selectedEmployee ? EmpId : null,
      // EmployeeIdString : selectedEmployee ? EmpId : null,
    }
   // console.log('req=>excwl',requestParams)
    axios
    .request({
      responseType: "blob",
      method: "POST",
      url: exportToExcelProductivity,
      data: requestParams,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
      },
    })
    .then((response) => {
      fileDownload(response.data, "Productivity.xlsx");
    })
    .catch((error) => {
      console.error(error.response.data);
    });

  }

  const handleDateChange = (newDate) => {
      
    const formattedDate = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
  
    
    const utcDate = new Date(Date.UTC(formattedDate.getFullYear(), formattedDate.getMonth(), formattedDate.getDate()));
    const dateToSend = utcDate.toISOString().split('T')[0]; 

    setDate(dateToSend);
    
  };

  const onClickFunction = async(apiFieldName:any)=>{

    if(apiFieldName === 'reset'){
      //console.log('date==>',moment().startOf('month').toDate())
      setDate(localDateFormatted);
      setSelectedEmployee([]);
      setIsReset(!isReset)
      
    }

    else if(apiFieldName === 'Submit'){ 
        await GetGridData()
    }
  }

  return (
    <>
      <Heading title={"Productitvity"}></Heading>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
              <div className="d-flex justify-content-between">
                <div>
                  <button
                    onClick={() => navigate("create")}
                    className="btn btn-update"
                  >
                    Create
                  </button>
                </div>
                <div className="d-flex gap-2">
                  <button
                    onClick={() => ExportToExcel()}
                    className="btn btn-export"
                  >
                    Export to Excel
                  </button>
                  <a className="filterIcon" onClick={toggleFilter}>
                    <i className="fa fa-filter"></i>
                  </a>
                </div>
              </div>
          </div>

          <div className="col-lg-12">
            {toggle && (
                <>
                  <div className="row mt-3" id="filterContent">
                
                    <div className="col-lg-4 col-md-4 col-sm-6">
                      <div className="form-group">
                          
                        <label className="d-block">
                          Date 
                        </label>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            views={["year", "month"]}
                            label="Year and Month"
                            value={date}
                            maxDate={lastDayOfPreviousMonth}
                            onChange={(e) => {
                              handleDateChange(e)
                            }}
                            renderInput={(params) => (
                              <TextField size="small" {...params} />
                            )}
                          />
                        </LocalizationProvider>
                          
                                    
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-6">
                      <div className="form-group">
                          <label>
                            Name 
                          </label>
                          <SelectForm
                            placeholder={"select"}
                            value={selectedEmployee}
                            options={employeeDropdown}
                            onChange={(event) => setSelectedEmployee(event)}
                            isMulti={true}
                            noIndicator={false}
                            noSeparator={false}

                          />
                        {/* <p style={{ color: "red" }}>{FormErrors["selectedEmployee_isEmpty"]}</p> */}
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="d-flex gap-2 justify-content-end">
                        <button
                          onClick={() => onClickFunction("reset")}
                          className="btn btn-reset"
                        >
                          Reset
                        </button>
                        <button
                          onClick={() => onClickFunction("Submit")}
                          className="btn btn-submit"
                        >
                          Submit
                        </button>
                      </div>
                    </div>

                  </div>
                  
                </> 
            )}
          </div>

          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={options}
              data={productivityGridData}
              columns={gridColumns}
            />
          </div>

        </div>
      </div>
    </>
  )
}

export default Productivity
